import React from 'react';
import { useNavigation } from '@react-navigation/native';
import StubScreen from './_StubScreen';

export default function ShopDashboardScreen() {
  const navigation = useNavigation();
  return (
    <StubScreen
      title="Shop Owner Dashboard"
      sourcePath="garageiq-web/app/shop/dashboard/page.js"
      summary="Shop-facing dashboard: stats (quote requests, active customers, revenue), service pricing editor, incoming quote rows, settings panel."
      todo={[
        'Stats grid → flex-wrap. StatCard component is small — port inline.',
        'Service pricing rows use a row-level edit toggle; useState per-row is fine on mobile.',
        'Quote request rows include an action menu — RN equivalent is Alert.alert with destructive option.',
        'Settings modal → RN bottom-sheet (react-native-bottom-sheet) or stack push.',
        'All data is currently mock; hook to the real API once the backend is up.',
      ]}
      ctaLabel="Back to Shop Sign-Up"
      onCta={() => navigation.navigate('ShopSignup')}
    />
  );
}
